import { Spinner } from "react-bootstrap";


export interface LoadingScreenProps {
    message: string
}

export function LoadingScreen({ message }: LoadingScreenProps) {
    return <div className="d-flex flex-column justify-content-center align-items-center vh-100 vw-100 bg-cyan-300">

        <div className="d-flex flex-column justify-content-center align-items-center">
            <Spinner animation="border" variant="white" />
            <p className="text-white my-4">{message}</p>
        </div>
    </div>
}